export { InfoDialog } from './src/info-dialog';
